<template>
  <div class="parent" v-show="webCart">
    <div class="cart">
      <Cart
        v-if="showCart"
        @showWebOrderModal="openWebOrder = !openWebOrder"
        @showCheckoutModal="openCheckout = !openCheckout"
        @loadOrderLineItem="sendItem"
        @close-cart="closeCart" />
    </div>
  </div>
  <CheckoutModal ref="checkoutChild" @showWebOrderModal="openWebOrder = !openWebOrder" :open="openCheckout" />
  <div class="cart-icon" @click="topScroll">
    <div class="cart-count">{{ cartCount }}</div>

    <font-awesome-icon class="icon" icon="cart-shopping" size="lg" />
  </div>

  <WebOrderModal :open="openWebOrder" />
</template>
<script>
import { mapGetters } from "vuex";

// import HistoryColumn from "../History/HistoryColumn.vue";
import Cart from "./Cart.vue";
import CheckoutModal from "./CheckoutModal.vue";
import WebOrderModal from "./WebOrderModal.vue";

export default {
  name: "CartColumn",
  components: {
    // HistoryColumn,
    Cart,
    CheckoutModal,
    WebOrderModal,
  },

  mounted() {
    if (this.open) {
      this.openCheckout = this.checkoutOpen;
    }
  },

  computed: {
    ...mapGetters({
      cartCount: "cartCount",
      socketConnected: "socketConnected",
      products: "cartProducts",
      allProducts: "allProducts",
    }),
    readyToRedirect() {
      return this.socketConnected && this.allProducts && this.allProducts.length > 0;
    },
  },
  emits: ["loadOrderLineItem"],
  props: ["open", "checkoutOpen"],
  data() {
    return {
      showCart: true,
      openCheckout: false,
      webCart: false,
      portrait: false,
      openWebOrder: false,
      cartRestoreAttempted: false,
    };
  },
  methods: {
    sendItem(item) {
      this.$emit("loadOrderLineItem", item);
    },

    closeCart() {
      this.showCart = false;
      this.webCart = false;
    },

    showTab(column) {
      column === "cart" ? (this.showCart = true) : false;
    },

    topScroll() {
      this.showCart = true;
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (window.screenTop < window.innerHeight) {
        this.webCart = !this.webCart;
      } else {
        this.webCart = true;
      }
      this.$store.dispatch("setCurrentTime", new Date());
    },

    restoreCartFromServer() {
      this.channel.push("cart:get", {}).receive("ok", (reply) => {
        if (reply.items && reply.items.length > 0) {
          const items = reply.items.map((item) => ({
            hash: item.hash,
            id: item.id,
            complete: item.complete || false,
            modifiers: item.modifiers || {},
            price: item.price,
            quantity: item.quantity,
            allergens: item.allergens || [],
          }));
          this.$store.dispatch("initialiseCartFromLocalStorage", { products: items, payments: [] });
          if (reply.expires_in > 0) {
            window.dispatchEvent(new CustomEvent("beamy:cart-expires-in", { detail: reply.expires_in }));
          }
        }
      });
    },

    redirect() {
      if ("redirect_status" in this.$route.query) {
        if (this.$route.query.redirect_status == "succeeded") {
          this.$refs.checkoutChild.completeTransaction(false, true);
          this.$notify({
            text: "Payment Succeeded.",
            type: "success",
            duration: 1500,
          });
        } else {
          this.$notify({
            text: "Payment Failed.",
            type: "error",
            duration: 1500,
          });
        }
      }
    },
  },
  watch: {
    readyToRedirect(val) {
      if (val && !this.cartRestoreAttempted) {
        this.cartRestoreAttempted = true;
        this.restoreCartFromServer();
      }
    },
    products() {
      if (this.products.length > 0 && this.socketConnected && "redirect_status" in this.$route.query) {
        this.redirect();
      }
    },
  },
};
</script>
<style scoped lang="scss">
// .parent {
//   display: flex;
//   flex-direction: column;

//   padding: 0rem 1rem 0rem 1rem;
//   background-color: var(--secondary-colour);
//   width: 20rem;
//   border-radius: 1rem 0rem 0rem 0rem;
//   .title {
//     .active {
//       color: var(--action-colour);
//     }
//     .dull {
//       color: var(--text-colour);
//     }
//   }
// }

.cart-icon {
  display: none;
}
.parent {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: 10000;
}
.cart-icon {
  position: fixed;
  top: auto;
  bottom: 1rem;
  right: 1rem;
  color: var(--action-colour);
  cursor: pointer;
  background-color: var(--secondary-colour);
  border: 1px solid black;
  box-shadow: var(--box-shadow);
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;

  .icon {
    width: 2rem;
  }
  .cart-count {
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: var(--warning-colour);
    color: var(--secondary-text-colour);
    box-shadow: var(--box-shadow);
    border: 1px solid black;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
  }
}
</style>
